"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _gatsby = require("gatsby");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _store = require("../store");

var _actions = require("../actions");

var _routes = _interopRequireDefault(require("../routes"));

var _templateObject;

var AvatarMenu = function AvatarMenu(props) {
  var ghost = props.ghost;

  var _ref = (0, _store.useStore)(),
      _ref2 = _slicedToArray(_ref, 2),
      config = _ref2[0].config,
      dispatch = _ref2[1];

  var handleSignOut = function handleSignOut() {
    return _actions.authActions.signOut({
      callback: function callback() {
        return (0, _gatsby.navigate)('/');
      }
    }, dispatch, config);
  };

  var dropDownMenu = /*#__PURE__*/_react.default.createElement(StyledMenu, null, /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, null, /*#__PURE__*/_react.default.createElement(_gatsby.Link, {
    to: (0, _routes.default)('profile')
  }, "Profile")), /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
    onClick: handleSignOut
  }, "Logout"));

  return /*#__PURE__*/_react.default.createElement(_antd.Dropdown, {
    overlay: dropDownMenu,
    arrow: true,
    trigger: ['click']
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    size: 32,
    icon: /*#__PURE__*/_react.default.createElement(_icons.UserOutlined, null),
    ghost: ghost
  })));
};

var StyledMenu = (0, _styledComponents.default)(_antd.Menu)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 150px;\n"])));
var _default = AvatarMenu;
exports.default = _default;